module.exports = __webpack_public_path__ + "img/hiPRO_logo.7eade7d9.png";